import {Box, Loading} from '@viptech/react-components'
import {useLayoutEffect, useRef, useState} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {useAuth} from 'src/contexts/AuthContext'
import {isMigratedLegacyPath, isPortalRouteHybridEnabled, navigateToMigratedRouteOnNewPortal} from 'src/lib/portal-migration'
import {isNewPortalEnabledForPath} from 'src/lib/portal-migration/portal-module-prefs'
import {readPortalModulePrefsFromClientCookie} from 'src/lib/portal-migration/portal-module-prefs.client'

export function MigratedOutlet() {
  const {pathname, search} = useLocation()
  const {isAuth} = useAuth()
  const [bridgeFailed, setBridgeFailed] = useState(false)
  const bridgingRouteKeyRef = useRef<string | null>(null)

  const prefs = readPortalModulePrefsFromClientCookie()
  const shouldBridge = isPortalRouteHybridEnabled() && isAuth && isMigratedLegacyPath(pathname) && isNewPortalEnabledForPath(pathname, prefs)

  const routeKey = `${pathname}${search}`

  useLayoutEffect(() => {
    if (!shouldBridge || bridgeFailed) return
    if (bridgingRouteKeyRef.current === routeKey) return

    const result = navigateToMigratedRouteOnNewPortal(pathname, search)
    if (result.ok) {
      bridgingRouteKeyRef.current = routeKey
    } else {
      setBridgeFailed(true)
    }
  }, [bridgeFailed, pathname, routeKey, search, shouldBridge])

  useLayoutEffect(() => {
    if (!shouldBridge) {
      setBridgeFailed(false)
      bridgingRouteKeyRef.current = null
    }
  }, [shouldBridge])

  if (shouldBridge && !bridgeFailed) {
    return (
      <Box display='flex' justifyContent='center' align='center' minHeight='50vh' aria-busy='true' aria-label='Redirecionando'>
        <Loading size='30px' />
      </Box>
    )
  }

  return <Outlet />
}
